/**
 * Validates a password against platform requirements.
 * @param {string} password
 * @returns {{ valid: boolean, error: string | null }}
 */
export const validatePassword = (password) => {
  if (!password) return { valid: false, error: null };
  if (password.length < 8)
    return { valid: false, error: "Password must be at least 8 characters" };
  if (!/[A-Z]/.test(password))
    return { valid: false, error: "Password must contain an uppercase letter" };
  if (!/[a-z]/.test(password))
    return { valid: false, error: "Password must contain a lowercase letter" };
  if (!/[0-9]/.test(password))
    return { valid: false, error: "Password must contain a number" };
  return { valid: true, error: null };
};
